var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guide-manual"},[_c('top-bar'),_vm._v(" "),_c('guide-manual'),_vm._v(" "),_c('form-button',{staticClass:"accept-button",attrs:{"title":"Aceitar"},on:{"click":_vm.acceptTerms}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ccefa302","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/guide-manual-acceptance/GuideManualAcceptance.vue
// module id = 915
// module chunks = 0